import { FC, SyntheticEvent } from 'react'

import { IconStarFilled } from '@avantstay/backoffice-vectors'

import * as S from './RatingStars.styles'

export interface RatingStarsProps {
  rating: number
  maxRating?: number
  onSelectRating?: (newRating: number) => void
}

export const RatingStars: FC<RatingStarsProps> = ({ rating, maxRating = 5, onSelectRating }) => {
  const arrayOfStars = new Array(maxRating).fill(null)

  const isInteractive = !!onSelectRating

  return (
    <S.StarsWrapper>
      {arrayOfStars.map((_, index) => {
        const isStarActive = rating > index

        const handleClick = (event: SyntheticEvent) => {
          event.preventDefault()
          if (onSelectRating) {
            onSelectRating(index + 1)
          }
        }

        return (
          <S.IconStarWrapper
            key={`star-${index}-${Math.random()}`}
            $isActive={isStarActive}
            $isInteractive={isInteractive}
            onClick={handleClick}
          >
            <IconStarFilled />
          </S.IconStarWrapper>
        )
      })}
    </S.StarsWrapper>
  )
}
